import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const PersonPlus: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_29820)'>
        <path
          d='M15.1227 17.5522H13.638V16.0633C13.638 15.6926 13.3369 15.3906 12.9672 15.3906H11.0333C10.6636 15.3906 10.3625 15.6926 10.3625 16.0633V17.5522H8.87778C8.50813 17.5522 8.20703 17.8542 8.20703 18.2249V20.1644C8.20703 20.5351 8.50814 20.837 8.87778 20.837H10.3625V22.326C10.3625 22.6967 10.6636 22.9986 11.0333 22.9986H12.9672C13.3369 22.9986 13.638 22.6967 13.638 22.326V20.837H15.1227C15.4923 20.837 15.7934 20.5351 15.7934 20.1644V18.2249C15.7934 17.8542 15.4923 17.5522 15.1227 17.5522ZM14.8914 19.9311H13.4066C13.037 19.9311 12.7359 20.2331 12.7359 20.6038V22.0928H11.2634V20.6038C11.2634 20.2331 10.9623 19.9311 10.5926 19.9311H9.10791V18.4545H10.5926C10.9623 18.4545 11.2634 18.1525 11.2634 17.7818V16.2928H12.7359V17.7818C12.7359 18.1525 13.037 18.4545 13.4066 18.4545H14.8914V19.9311Z'
          fill='url(#paint0_linear_12280_29820)'
          stroke='url(#paint1_linear_12280_29820)'
          strokeWidth='0.9'
        />
        <path
          d='M14.8069 11.1342C16.3859 10.1755 17.4459 8.44478 17.4459 6.46117C17.4459 3.45135 15.0016 1 12.0003 1C8.99896 1 6.5546 3.45132 6.5546 6.46117C6.5546 8.44113 7.61704 10.1755 9.19358 11.1342C5.23256 11.7909 2.20312 15.2476 2.20312 19.4016V21.3754C2.20312 21.6233 2.40386 21.8283 2.65478 21.8283C2.9057 21.8283 3.10644 21.627 3.10644 21.3754V19.4016C3.10644 15.2784 6.45048 11.9261 10.5606 11.9261H13.4432C17.5546 11.9261 20.8974 15.2797 20.8974 19.4016V21.3754C20.8974 21.6233 21.0981 21.8283 21.3491 21.8283C21.6 21.8283 21.8007 21.627 21.8007 21.3754V19.4016C21.8007 15.2476 18.7701 11.791 14.8103 11.1342H14.8069ZM7.45551 6.46117C7.45551 3.94725 9.49593 1.9047 12.0028 1.9047C14.5097 1.9047 16.5501 3.95093 16.5501 6.46117C16.5501 8.97141 14.5097 11.0176 12.0028 11.0176C9.49593 11.0176 7.45551 8.97141 7.45551 6.46117Z'
          fill='url(#paint2_linear_12280_29820)'
          stroke='url(#paint3_linear_12280_29820)'
          strokeWidth='0.9'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_29820'
          x1='9.778'
          y1='15.9094'
          x2='13.251'
          y2='22.8504'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_29820'
          x1='9.778'
          y1='15.9094'
          x2='13.251'
          y2='22.8504'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_29820'
          x1='6.26134'
          y1='2.42026'
          x2='16.0951'
          y2='20.9653'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_29820'
          x1='6.26134'
          y1='2.42026'
          x2='16.0951'
          y2='20.9653'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_29820'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PersonPlus;
